module.exports = __webpack_public_path__ + "static/media/chevblue.52bffe09.svg";